import { IconActionPlaceholder } from '@cko/icons';
import { MenuIcons } from './MenuIcons';

export const getMenuIcon = (name?: string) => {
  if (!name) {
    return undefined;
  }
  return MenuIcons[name] || IconActionPlaceholder;
};
